import { useMutation } from "@tanstack/react-query"

import i18n from "@/i18n/config"
import { AddToCartResponse, SkiPassItem } from "@/types/Cart"

import { publicApi } from "../apiClient"

interface EditCartItemParams {
  cartItemId: string
  item: SkiPassItem
}

const useEditCartItem = () => {
  const mutation = useMutation<AddToCartResponse, Error, EditCartItemParams>({
    mutationKey: ["editCartItem"],
    mutationFn: async ({ cartItemId, item }) => {
      const response = await publicApi.post<AddToCartResponse>(
        `/skipass/app/cart/editcartitem?cultureName=${i18n.language}&cartItemId=${cartItemId}`,
        item
      )

      if (!response.data.Success) {
        throw new Error(response.data.ErrorMessage || "Unknown error occurred")
      }

      return response.data
    },
  })

  return {
    editCartItem: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
  }
}

export default useEditCartItem
